export const GLOBAL_MESSAGE_HANDLER_TOKEN = '__GLOBAL_MESSAGE_HANDLER_TOKEN__';